// extracted by mini-css-extract-plugin
module.exports = {"arrowSpan":"ArrowSpan_arrowSpan__WFA4t"};